import Separator from "@/common/components/separator";
import useHttpProvider from "@/common/hooks/use-http";
import { Plan } from "@/features/payments/models/plan";
import { Subscription } from "@/features/payments/models/subscription";
import * as SubscriptionServices from "@/features/payments/services/subscriptions";
import { useEffect, useState } from "react";
import AccumulatedEntriesComponent from "../components/accumulated-entries";
import CurrentDraws from "../components/current-draws";
import InformationAndReferrals from "../components/current-information";
import CurrentPlan from "../components/current-plan";

function ProfileDashboardPage() {
	const { http } = useHttpProvider();

	const [currentPlan, setCurrentPlan] = useState<Plan | null>(null);
	const [currentSubscription, setCurrentSubscription] =
		useState<Subscription | null>(null);

	async function getUserActiveSubscription() {
		const { plan, subscription } =
			await SubscriptionServices.getUserActiveSubscription(http);
		setCurrentPlan(plan);
		setCurrentSubscription(subscription);
	}

	useEffect(() => {
		getUserActiveSubscription();
	}, []);

	return (
		<div className="flex flex-col gap-12">
			<InformationAndReferrals />
			<Separator />
			<CurrentPlan plan={currentPlan} subscription={currentSubscription} />
			<Separator />
			<AccumulatedEntriesComponent />
			<Separator />
			<CurrentDraws />
		</div>
	);
}

export default ProfileDashboardPage;
